import { render, staticRenderFns } from "./LayoutAuth.vue?vue&type=template&id=bff1fbc6&"
import script from "./LayoutAuth.vue?vue&type=script&lang=js&"
export * from "./LayoutAuth.vue?vue&type=script&lang=js&"
import style0 from "@/vendor/styles/pages/authentication.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports